/**
 * Builds up-to-two uppercase initials for the avatar placeholder
 * (e.g. "Ada Lovelace" -> "AL"). Pure; safe for empty/whitespace names.
 */
export const getInitials = (name: string): string =>
  name
    .split(' ')
    .filter(Boolean)
    .map(word => word[0])
    .join('')
    .toUpperCase()
    .slice(0, 2)
